import axios from '@/user/axios.js'

const retrieveNews = () => {
  // TODO: localStorage で使うkeyが増えてきたら別ファイルにて管理する
  return JSON.parse(localStorage.getItem('news') || '[]')
}

const saveNews = (newsList) => {
  localStorage.setItem('news', JSON.stringify(newsList.map(({ id, readAt }) => ({ id, readAt }))))
}

const clearNews = () => {
  localStorage.removeItem('news')
}

const moduleNews = {
  namespaced: true,
  state: {
    newsList: []
  },
  mutations: {
    SET_NEWS_LIST (state, payload) {
      const newsListInLocalStorage = retrieveNews()
      state.newsList = payload.map(item => {
        const news = newsListInLocalStorage.find(n => n.id === item.id)
        if (news) {
          return {
            ...news,
            ...item
          }
        }
        return {
          ...item,
          readAt: null // 既読管理用
        }
      })
      // localStorageにお知らせを保存したあとにadmin画面で無効にされると整合性がとれなくなるため
      // 一回一回ストレージをクリアしてから再保存する
      clearNews()
      saveNews(state.newsList)
    },
    SET_NEWS_READ (state, id) {
      const index = state.newsList.findIndex(news => news.id === id)
      state.newsList = [
        ...state.newsList.slice(0, index),
        {
          ...state.newsList[index],
          readAt: new Date()
        },
        ...state.newsList.slice(index + 1)
      ]
      saveNews(state.newsList)
    }
  },
  actions: {
    listNews (context, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axios.get('/api/news/', {
            params: payload
          })
          if (res.data.success) {
            context.commit('SET_NEWS_LIST', res.data.data)
          }
          resolve(res)
        } catch (err) {
          reject(err)
        }
      })
    },
    setNewsRead (context, id) {
      context.commit('SET_NEWS_READ', id)
    }
  }
}

export default moduleNews
